import '@fontsource-variable/inter';
import '@tarja/ui/styles.css';
import './app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { instalarMensajesZod } from './lib/zod-es';

instalarMensajesZod();

async function iniciar() {
  // Modo simulado (VITE_MOCK=1): MSW intercepta el API con datos de ejemplo. Se excluye del build de producción.
  if (import.meta.env.VITE_MOCK === '1') {
    const { iniciarMock } = await import('./mock/browser');
    await iniciarMock();
  }
  const raiz = document.getElementById('root');
  if (!raiz) throw new Error('Falta #root');
  createRoot(raiz).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void iniciar();
